import { defineStore } from "pinia"

export const useSnackbarStore = defineStore("snackbar", () => {
	const successMsg = ref("")
	const errorMsg = ref("")
	const icon = ref<string | undefined>(undefined)
	const onClick = ref<(() => void) | undefined>(undefined)
	// Bumped on every set* call so the SnackBar watcher fires even when the message text matches
	// the previous notification (string equality on a reactive prop otherwise no-ops the watch).
	const trigger = ref(0)

	function setErrorMsg(msg: string) {
		errorMsg.value = msg
		successMsg.value = ""
		icon.value = undefined
		onClick.value = undefined
		trigger.value++
	}

	function setSuccessMsg(msg: string, ic: string | undefined = undefined, oc: (() => void) | undefined = undefined) {
		successMsg.value = msg
		errorMsg.value = ""
		icon.value = ic
		onClick.value = oc
		trigger.value++
	}

	function clear() {
		successMsg.value = ""
		errorMsg.value = ""
		icon.value = undefined
		onClick.value = undefined
	}

	return {
		successMsg,
		errorMsg,
		icon,
		onClick,
		trigger,
		setErrorMsg,
		setSuccessMsg,
		clear
	}
})
